import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { InvoiceCancelInfo } from '../models/invoices.models';

export const InvoiceDetails = createAction(
  '[Customer data: Invoice Info]: Invoice Details',
  props<{ gridData: any }>(),
);

export const InvoiceShowCoupons = createAction(
  '[Customer data: Invoice Info]: Invoice Show Coupons',
  props<{ gridData: any }>(),
);

export const InvoiceShowAttributes = createAction(
  '[Customer data: Invoice Info]: Invoice Show Attributes',
  props<{ gridData: any }>(),
);

export const LoadInvoiceDisplayedColumns = createAction(
  '[Customer data: Invoice Info]: Load Invoice Displayed Columns',
  props<{ displayedColumns: { [label: string]: string } }>(),
);

export const InvoiceInfoClosed = createAction('[Customer data: Invoice Info]: Invoice Info Closed');

export const CancelInfoInvoice = createAction(
  '[Customer data: Invoice Info]: Delete Invoice',
  props<{ invoiceId: number }>(),
);

export const CancelInfoInvoiceSuccess = createAction(
  '[Customer data: Invoice Info]: Delete Invoice Success',
  props<{ res: InvoiceCancelInfo }>(),
);

export const CancelInfoInvoiceFailed = createAction(
  '[Customer data: Invoice Info]: Delete Invoice Failed',
  props<{ error: HttpErrorResponse }>(),
);
